import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../components/breadcrumb/breadcrumb";
import { GetSVG } from "../components/images/getSVG/getSVG";
import { ILayoutPage } from "./interface";
import "./layoutPage.scss";

export const LayoutPage = ({
  title,
  titleChild,
  children,
  breadcrumb = [],
  returnTo,
  initialIconBreadcrumb,
  isSubPage,
}: ILayoutPage) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        className={`layoutpage-container ${
          !!breadcrumb.length ? "breadcrumb-space" : ""
        } ${isSubPage ? "sub-page" : ""}`}
      >
        <div className="title">
          {returnTo && (
            <div
              className="return-icon"
              onClick={() => {
                navigate(returnTo);
              }}
            >
              <GetSVG svgName="CaretLeft" size={16} />
            </div>
          )}
          {title}
        </div>
        {titleChild}
      </div>
      {!!breadcrumb.length && (
        <div className="breadcrumb-route">
          {initialIconBreadcrumb}
          <Breadcrumb routes={breadcrumb} />
        </div>
      )}
      {children}
    </>
  );
};
